export default "__VITE_ASSET__CuVF3OJv__"